var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":`${_vm.url}?mls=1`,"allowfullscreen":"","allow":"vr;accelerometer;gyroscope;fullscreen"}})
}
var staticRenderFns = []

export { render, staticRenderFns }